import { Badge, Typography } from 'antd';
import { useTranslation } from 'translations';
import Timestamp from './Timestamp';

const SUCCESS = 'success' as const;
const DEFAULT = 'default' as const;

interface NetworkConnectionStatusProps {
  value?: any;
}

function NetworkConnectionStatus({ value = null }: NetworkConnectionStatusProps) {
  const { tC } = useTranslation('components', 'helpers.networkConnection');

  if (!value) {
    return '-';
  }

  let connection;
  if (value.online !== undefined) {
    connection = value;
  } else {
    connection = value.stable_connection || value.connection;
  }

  if (!connection) {
    return '-';
  }

  const status = connection.online
    ? {
        badgeStatus: SUCCESS,
        text: tC('online'),
      }
    : {
        badgeStatus: DEFAULT,
        text: (
          <>
            <Typography.Text type="secondary">{tC('lastSeen')} </Typography.Text>
            <Timestamp timestamp={connection.timestamp} fromNow />
          </>
        ),
      };

  return <Badge status={status.badgeStatus} text={status.text} />;
}

export default NetworkConnectionStatus;
